import css from '@styled-system/css';
import { useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { numberWithCurrency } from 'hb-react/shared/utils/formatNumber';

export const Price = ({ price, currency, hasFreeTrial = false }) => {
  const { currentUser } = useDefaultAppContexts();
  const locale = currentUser?.locale || I18n.locale || 'en-US';

  const value = useMemo(() => {
    if (Number(price) === 0) {
      return __('Free');
    }

    return numberWithCurrency(price, currency, {
      minimumFractionDigits: Number.isInteger(Number(price)) ? 0 : 2,
      locale,
      currencyDisplay: 'symbol',
    });
  }, [price, currency, locale]);

  return (
    // eslint-disable-next-line react/no-unknown-property
    <span css={css({ whiteSpace: 'nowrap' })}>{`${
      hasFreeTrial ? s__('Memberships|Then ') : ''
    }${value}`}</span>
  );
};
